module.exports = __webpack_public_path__ + "static/media/Icon-EditorCopy.918e1e6e.png";